import React from 'react';
import isArray from 'lodash/isArray';

export function getImages(images, otherPropsImg = {}) {
  const singleString = typeof images === 'string';
  const imageObj = images && !!images.id;
  const imagesIsArray = isArray(images);

  let titleImage = imagesIsArray && images[0] ? images[0] : { id: null };
  if (singleString) titleImage = { id: images || null };
  if (imageObj) titleImage = images;
  titleImage = {
    ...titleImage,
    renderer: titleImage.renderer || 'orig',
    alt: otherPropsImg.alt || '',
    title: otherPropsImg.title || null
  };

  return {
    titleImage,
    singleString,
    imageObj,
    imagesIsArray
  };
}
